// extracted by mini-css-extract-plugin
export default {"button-color-primary":"#ff6000"};